var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { dictionary } from '@mf-cms/helpers';
import styles from './qa-dialog.styles';
import { MFElement } from '../mfelement/mfelement';
/** Mediaflow's Q&A terms, used when the live page has no terms link of its own. */
const DEFAULT_TERMS_URL = 'https://www.mediaflow.com/qna-terms/';
let PQADialog = class PQADialog extends MFElement {
    constructor() {
        super(...arguments);
        this.culture = 'en-GB';
        this.postError = false;
        this.paused = false;
        this.postSuccess = false;
    }
    static { this.styles = styles; }
    open() {
        this.dialog.open();
    }
    async send() {
        const name = this.nameEl.value;
        const question = this.questionEl.value;
        const acceptedTermsOfUse = this.termsOfUseEl.checked;
        let hasError = false;
        if (!question.length) {
            this.questionEl.error = dictionary(this.culture, 'qa', 'questionsLengthError');
            hasError = true;
        }
        else {
            this.questionEl.removeAttribute('error');
        }
        if (!acceptedTermsOfUse) {
            this.termsOfUseEl.error = dictionary(this.culture, 'qa', 'questionsTermsOfUseError');
            hasError = true;
        }
        else {
            this.termsOfUseEl.removeAttribute('error');
        }
        if (hasError) {
            return;
        }
        this.submitButton.loading = true;
        fetch(`${process.env.MEDIA_API_URL}/livestream/${this.mediaId}/questions`, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name,
                question,
                acceptedTermsOfUse
            })
        }).then((res) => {
            if (res.status === 200) {
                this.postError = false;
                this.questionEl.removeAttribute('error');
                this.submitButton.loading = false;
                this.postSuccess = true;
            }
            else {
                this.submitButton.loading = false;
                this.postError = true;
                this.render();
            }
        });
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <p-dialog heading=${dictionary(this.culture, 'qa', 'askAQuestion')} culture=${this.culture}> ${this.paused ? html ` <div class="info-message" aria-live="assertive">
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-info-circle"
                viewBox="0 0 16 16"
              >
                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                <path
                  d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
                />
              </svg>
              ${dictionary(this.culture, 'qa', 'qaPaused')}
            </div>`
            : ''}
        ${this.postError
            ? html `<div class="error-message" aria-live="assertive"> ${dictionary(this.culture, 'qa', 'qaSentFailed')} </div>`
            : ''}
        ${this.postSuccess
            ? html ` <div class="success"> <svg aria-hidden="true" class="checkmark-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" > <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" /> <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" /> </svg> <h2>${dictionary(this.culture, 'qa', 'successHeading')}</h2> <p-button @p-click=${() => (this.postSuccess = false)} >${dictionary(this.culture, 'qa', 'askAnotherQuestion')}</p-button > </div> <p-button @p-click=${() => this.dialog.close()} slot="footer" color="border" >${dictionary(this.culture, 'general', 'close')}</p-button > `
            : html ` <p-input class="input-name" input-id="name" label=${dictionary(this.culture, 'qa', 'name')} ></p-input> <p-textarea class="input-question" input-id="question" label=${dictionary(this.culture, 'qa', 'question')} required ></p-textarea> <p-checkbox class="input-terms" input-id="terms-and-conditions" required> ${dictionary(this.culture, 'qa', 'iAgreeWithThe')} <a href=${this.termsUrl || DEFAULT_TERMS_URL} target="_blank" >${dictionary(this.culture, 'qa', 'termsAndConditions')}</a > </p-checkbox> <p-button @p-click=${() => this.dialog.close()} slot="footer" color="border" >${dictionary(this.culture, 'general', 'close')}</p-button > <p-button ?disabled=${this.paused} class="submit-button" @p-click=${() => this.send()} slot="footer" color="primary" >${dictionary(this.culture, 'qa', 'submit')}</p-button > `}
      </p-dialog>
    `;
    }
};
__decorate([
    property({ type: String, attribute: 'media-id' })
], PQADialog.prototype, "mediaId", void 0);
__decorate([
    property({ type: String, attribute: 'terms-url' })
], PQADialog.prototype, "termsUrl", void 0);
__decorate([
    property({ type: String })
], PQADialog.prototype, "culture", void 0);
__decorate([
    property()
], PQADialog.prototype, "postError", void 0);
__decorate([
    property({ type: Boolean })
], PQADialog.prototype, "paused", void 0);
__decorate([
    query('p-dialog')
], PQADialog.prototype, "dialog", void 0);
__decorate([
    query('.input-name')
], PQADialog.prototype, "nameEl", void 0);
__decorate([
    query('.input-question')
], PQADialog.prototype, "questionEl", void 0);
__decorate([
    query('.input-terms')
], PQADialog.prototype, "termsOfUseEl", void 0);
__decorate([
    query('.submit-button')
], PQADialog.prototype, "submitButton", void 0);
__decorate([
    state()
], PQADialog.prototype, "postSuccess", void 0);
PQADialog = __decorate([
    customElement('p-qa-dialog')
    /**
     * PRating component
     *
     * @class PRating
     * @typedef {PRating}
     * @extends {LitElement}
     */
], PQADialog);
export { PQADialog };
